module.exports = __webpack_public_path__ + "static/media/mot-icon.a35fb523.svg";